export default "__VITE_ASSET__Dux3Kqrg__"